import Share from 'tencent-share'
import { urlPrefix } from '@/core/config'

interface ShareInfoProps {
  title?: string
  desc?: string
  img?: string
  link?: string
}

// 获取分享地址
export const getShareLink = (page: string) => {
  return `${urlPrefix}/show/_${Date.now().toString(36)}/fireworks/${page}`
}

// 首页/推广页
export const shareInfo = {
  title: '与亲友互送跨年烟花，领现金红包！',
  desc: '百万烟花秀，绽放新一年',
  img: 'https://sola.gtimg.cn/aoi/sola/20201223173249_E809S0Hart.jpg',
  link: getShareLink('share.html')
}

// 送烟花分享页
export const shareSendInfo = {
  title: '在腾讯新闻头版定制了烟花红包，快来看吧~',
  desc: '打开腾讯新闻app观看，还有红包领哦！',
  img: 'https://sola.gtimg.cn/aoi/sola/20201223173249_E809S0Hart.jpg',
  link: getShareLink('send.html')
}

// 解锁分享页
export const shareInviteInfo = {
  title: '解锁烟花名称真好看，想和你一起拥有！快来送我，你也可以免费领~',
  desc: '百万烟花秀，绽放新一年',
  img: 'https://sola.gtimg.cn/aoi/sola/20201223173249_E809S0Hart.jpg',
  link: getShareLink('invite.html')
}

// 设置分享信息
export const setShareInfo = async (params: ShareInfoProps) => {
  const info = {
    ...{
      title: '',
      desc: '',
      img: '',
      link: ''
    },
    ...shareInfo,
    ...params
  }
  new Share(info)
}

// 显示分享面板
export const showShare = async () => {
  const share = new Share()
  share.show()
  console.log('show')
}

export const shareToWechat = () => {
  console.log(`shareToWechat`)
  const share = new Share()
  share.shareToApp('wechatFriend')
}

export const shareToQQ = () => {
  const share = new Share()
  share.shareToApp('qqFriend')
}

export const shareToMoments = () => {
  const share = new Share()
  share.shareToApp('moments')
}
